module.exports = __webpack_public_path__ + "img/rocketLaunch.92b116f2.svg";